import { Row } from '@tanstack/react-table';
import Button from 'components/button/Button';
import Tooltip from 'components/tooltip/Tooltip';
import {
  IntegrationEnum,
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import useIntegrationDescriptionModal from 'pages/integrations/modals/integrationDescription/useIntegrationDescriptionModal';
import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AccessLink from './AccessLink';
import { IntegrationCellWrapper } from './IntegrationCell.styles';
import Badge from './badge';

const IntegrationCell = ({ row }: { row: Row<InternalIntegrationSetting> }) => {
  const { t } = useTranslation();
  const { name, logo, displayName } = row.original.integration;
  const { openIntegrationDescriptionModal } = useIntegrationDescriptionModal();
  const isIntegrationEnabled =
    row.original.agencySettings.status === IntegrationStatus.ACTIVE;

  const integrationName = displayName ?? name;
  const integrationId = row.original.integration.enumId;
  const shouldShowTooltip = [
    IntegrationEnum.STRIPE,
    IntegrationEnum.PAYPAL,
  ].includes(integrationId);

  return (
    <IntegrationCellWrapper>
      <img
        src={logo}
        alt={`${integrationName} logo`}
        width={48}
        height={48}
        loading="lazy"
      />

      <p>{integrationName}</p>

      <div className="badges">
        {row.original.integration.badges.map((badge) => (
          <Badge key={badge} type={badge} />
        ))}
      </div>

      <div className="actions">
        <div>
          <Button
            bsStyle="link"
            onClick={(e) => {
              e.stopPropagation();
              openIntegrationDescriptionModal(row.original);
            }}
            data-testid="integration-description-button"
          >
            {t('pageIntegrations.table.viewDescription')}
          </Button>

          {shouldShowTooltip && (
            <Tooltip
              text={t('pageIntegrations.table.paymentProcessorWarning')}
              id="transaction-fee-tooltip"
            >
              <Glyphicon
                glyph="info-sign"
                data-testid="transaction-fee-tooltip"
              />
            </Tooltip>
          )}
        </div>

        {isIntegrationEnabled && <AccessLink integrationId={integrationId} />}
      </div>
    </IntegrationCellWrapper>
  );
};

export default IntegrationCell;
